import type { Feature } from '@faceup/utils'
import { useInstitution } from '../providers'

export const useEntitlement = () => {
  const {
    data: { entitlements },
  } = useInstitution({
    __unsafeSkipCheckIfNotWrappedInInstitutionProvider: true,
  })

  return (feature: Feature) =>
    entitlements.find(entitlement => entitlement.id === feature)?.isEnabled ?? false
}
